import { Typography } from '@mui/material'
import { EmailOutlined, PhoneOutlined } from '@mui/icons-material'
import * as React from 'react'

interface IContactAdminButtonProps {
  school: any
  textStyle?: React.CSSProperties
}

export default function ContactAdminButton(props: IContactAdminButtonProps) {
  return (
    <>
      <div style={{ width: '100%' }}>
        <Typography
          style={{
            textDecoration: 'none',
            display: 'flex',
            marginBottom: '5px',
            ...props.textStyle,
          }}
          href={`tel:${props.school.phone_no}`}
          component="a"
          color="textPrimary"
          variant={'body2'}
        >
          <PhoneOutlined fontSize={'small'} style={{ marginRight: '10px' }} />{' '}
          Phone: {'  ' + props.school.phone_no}
        </Typography>
        <Typography
          style={{
            textDecoration: 'none',
            display: 'flex',
            ...props.textStyle,
          }}
          href={`mailto:${props.school.email}`}
          component="a"
          variant={'body2'}
          color="textPrimary"
        >
          <EmailOutlined fontSize={'small'} style={{ marginRight: '10px' }} />{' '}
          Email: {'  ' + props.school.email}
        </Typography>
      </div>
      {/* <Button */}
      {/*  style={{ margin: "10px 0px" }} */}
      {/*  variant="outlined" */}
      {/*  size={"small"} */}
      {/*  // fullWidth={true} */}
      {/*  href={`mailto:${props.school.email}`} */}
      {/*  color="primary" */}
      {/* > */}
      {/*  Send a mail to admin */}
      {/* </Button> */}
    </>
  )
}
